import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { CheckItem } from '../CheckItem';
import { CORE_PROMISE, withoutSystem, withSystem } from '../../data/salesContent';
export function ComparisonSection() {
  return <section className="border-t border-line bg-canvas px-5 py-20 md:py-28" data-id="element-92" data-mp="4zl0mo5qyyc6">
      <div className="mx-auto max-w-5xl" data-id="element-93" data-mp="9yo7me5afems">
        <SectionHeading title="Preparar todo desde cero vs. trabajar con un sistema" data-id="element-94" data-mp="9xmkvcewt3p8" />
        <div className="mt-14 grid gap-6 md:grid-cols-2" data-id="element-95" data-mp="3ree7cf38owri">
          <div className="rounded-2xl border border-line bg-surface/60 p-7 md:p-9" data-id="element-96" data-mp="1tb20skrob5">
            <h3 className="text-xl font-black uppercase tracking-wide text-muted md:text-2xl" data-id="element-97" data-mp="3if95ozwdsnb4">Sin el MegaPack</h3>
            <ul className="mt-6 space-y-4" data-id="element-98" data-mp="3ndu9186xjn3s">
              {withoutSystem.map(i => <CheckItem key={i} variant="cross" className="text-lg text-muted" data-id="element-99" data-mp="3nbznbrnu3qyn">
                  {i}
                </CheckItem>)}
            </ul>
          </div>
          <div className="rounded-2xl border-2 border-accent bg-raised p-7 md:p-9" data-id="element-100" data-mp="3dev1xu1tbziw">
            <h3 className="text-xl font-black uppercase tracking-wide text-accent md:text-2xl" data-id="element-101" data-mp="z6o92vw3kvh3">Con el MegaPack</h3>
            <ul className="mt-6 space-y-4" data-id="element-102" data-mp="u84k0mm7j3ki">
              {withSystem.map(i => <CheckItem key={i} className="text-lg font-medium text-ink" data-id="element-103" data-mp="188xg3bs5q6pq">
                  {i}
                </CheckItem>)}
            </ul>
          </div>
        </div>
        <p className="mt-14 text-center text-2xl font-black uppercase leading-tight tracking-tight text-ink md:text-4xl" data-id="element-104" data-mp="144zdus7jcfsg">{CORE_PROMISE}</p>
      </div>
    </section>;
}